const WORDS = [
  "Websites", "Branding", "AI Chatbots", "Bookings & Payments", "SEO",
  "Google & Meta Ads", "Photography", "Social Media", "CRM Setup", "Automation",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="bg-ink py-6 overflow-hidden relative" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {WORDS.map((w) => (
            <span key={`${copy}-${w}`} className="flex items-center">
              <span className="font-display font-semibold text-white/85 text-lg sm:text-xl tracking-tight px-6">{w}</span>
              <span className="w-2 h-2 rounded-full bg-gradient-to-r from-indigo to-mint shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
